import { render, staticRenderFns } from "./orthopedic-features-grid.vue?vue&type=template&id=cf4ba784&scoped=true&"
import script from "./orthopedic-features-grid.vue?vue&type=script&lang=js&"
export * from "./orthopedic-features-grid.vue?vue&type=script&lang=js&"
import style0 from "./orthopedic-features-grid.vue?vue&type=style&index=0&id=cf4ba784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4ba784",
  null
  
)

export default component.exports